module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.popupShow) ? _c('div', {
    staticClass: "popup-modal"
  }, [_c('div', {
    staticClass: "popup-modal-mask",
    on: {
      "click": function($event) {
        _vm.popupShow = !_vm.popupShow
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-container"
  }, [_c('div', {
    staticClass: "emoji-container clear"
  }, [_c('ul', {
    staticClass: "emoji-list block clear pull-left"
  }, _vm._l((_vm.emoji), function(item) {
    return _c('li', {
      domProps: {
        "innerHTML": _vm._s(item)
      },
      on: {
        "click": _vm.insertEmoji
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93f46dec"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/emoji/index.vue
// module id = 288
// module chunks = 107